import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-icon',
  templateUrl: './loading-icon.component.html',
  styleUrls: ['./loading-icon.component.scss']
})
export class LoadingIconComponent {
  /**
   * Whether loading icon should appear or not
   */
  @Input() loading = false;

  /**
   * Loading icon speed animation
   */
  @Input() slow = false;
}
